import styles from './style.module.css';

// A person's initials in a circle, where the blueprint draws a face: in the
// top bar, the phone menu, the patient list and the clinician cards. large
// is the size that heads a page. It is decoration beside the written name,
// so assistive technology skips it.
export function Initials({ firstName, lastName, large }) {
  const letters = `${ firstName.slice(0, 1) }${ lastName.slice(0, 1) }`.toUpperCase();
  let className = styles.initials;

  if (large === true) {
    className = `${ styles.initials } ${ styles.large }`;
  }

  return <span className={ className } aria-hidden='true'>{ letters }</span>;
}
